"use client";

import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { IBlocks } from "@/types";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import React from "react";
import { startsWithHTTPS } from "@/lib/utils";
import { toast } from "sonner";
interface Props {
    block: IBlocks;
    blockUpdate: React.Dispatch<React.SetStateAction<IBlocks>>;
    update: (value: IBlocks) => void;
}
export default function PodbeanOptions({ block, blockUpdate, update }: Props) {
    const [oldBlock, setOldBlock] = React.useState(block);
    const [url, setUrl] = React.useState(block.url);
    return (
        <div className="flex w-full flex-col gap-3">
            <Input
                label="PodBean RSS URL"
                variant="card"
                className="w-full"
                placeholder="https://feed.podbean.com"
                required
                value={url}
                onChange={(e) => {
                    setUrl(e.target.value);
                    blockUpdate({
                        ...block,
                        url: e.target.value,
                    });
                }}
                onBlur={(e) => {
                    if (
                        !e.target.value.startsWith("https://feed.podbean.com")
                    ) {
                        return toast.error(
                            "Make sure you add https://feed.podbean.com to the URL"
                        );
                    }
                    if (oldBlock.url != e.target.value) {
                        update({
                            ...block,
                            url: e.target.value,
                        });
                        setOldBlock({
                            ...oldBlock,
                            url: e.target.value,
                        });
                    }
                }}
            />
        </div>
    );
}
